import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageTableHeader from "../../components/pageTableHeader/pageTableHeader";
import { EditStaffProfile } from "../../components/forms/profile/editStaffProfileForm";
import { useSelector } from "react-redux";
import Loading from "../../components/skeleton/loading";

const EditProfile = () => {
  const navigate = useNavigate(); 
  const [selectedValue, setSelectedValue] = useState("");
  const { role } = useSelector((state) => state.user);
  const [isLoading, setIsLoading] = useState(true);

  const items = [
    { label: "Home", path: "/" },
    { label: "Profile", path: "/profile" },
    { label: "Edit Profile", path: "" },
  ];


  useEffect(() => { 
    setIsLoading(true);
    if(role)
    {
      if (role === 3) {

        setSelectedValue("student");
        setIsLoading(false);
      } else {
        setSelectedValue("staff");
        setIsLoading(false);
      }
    }
   
   
  }, [role]);
  return (
    <div className="w-full flex flex-col gap-2">
      <PageTableHeader
        breadcrumbs={items}
        isSearch={false}
        isFilter={false}
        buttons={false}
      />
      {isLoading ? (
        <div className="flex justify-center items-center h-full">
            <Loading />
        </div>
      ) : (
         <EditStaffProfile />
      )}
    </div>
  );
};

export default EditProfile;
